'use client';

import Map from 'src/components/Map';
import useMapState from 'src/hooks/useMapState';
import InternalMapProvider from 'src/components/InternalMapProvider';

function InternalLayoutView({ children }) {
    const { hoveredItem } = useMapState();

    return (
        <div className="relative flex flex-col lg:flex-row">
            <section className="bg-primary top-nav-sm-height lg:h-screen-nav-md md:top-nav-md-height h-map-sm-height sticky w-full md:z-20 md:h-[350px] lg:order-last lg:w-1/3 xl:w-1/2">
                <Map id="locationsMap" highlightedLocation={hoveredItem} />
            </section>
            <section className="drop-shadow-t-lg bg-lightest-grey relative z-0 overflow-visible pb-8 md:mt-0 md:pb-16 md:drop-shadow-none lg:w-2/3 xl:w-1/2">
                {children}
            </section>
        </div>
    );
}

export default function InternalLayout({ children, accessToken }) {
    return (
        <InternalMapProvider accessToken={accessToken}>
            <InternalLayoutView>{children}</InternalLayoutView>
        </InternalMapProvider>
    );
}
